import env from 'env'

export const getContacts = () => ({
  type: 'CONTACTS/SUPPORT',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/contacts/support',
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})

getContacts.toString = () => 'CONTACTS/SUPPORT'
